const API_BASE_URL = "https://kitanax.pro/api";

export default API_BASE_URL;
